export default __webpack_public_path__ + "static/media/q_wdt_c_5.f473bc03.mp3";